import { FC } from "react";
import Line from "../Line/Line";

import { useFooterData } from "../../hooks/api/useFooterData";

import "./Footer.css";

const Footer: FC = () => {
  const { data } = useFooterData();

  // Жесткая проверка: если основных данных нет — не рендерим ничего
  if (!data?.data?.attributes) {
    return null;
  }

  const { attributes } = data.data;

  return (
    <div className="container">
      <Line />
      <div className="footer">
        <div className="footer__links-wrapper">
          <p>{attributes.social_links_title}</p>
          <div className="footer__links">
            {/* Безопасный обход массива через ?.map */}
           {attributes.social_links?.map(({ href, icon, id, alt }) => {
  // Достаем первый элемент из массива картинок, если он существует
  const iconData = Array.isArray(icon?.data) ? icon.data[0] : icon?.data;
  const iconUrl = iconData?.attributes?.url;

  return (
    <a
      key={id}
      target="_blank"
      rel="noreferrer"
      href={href}
      className="footer__link"
    >
      {iconUrl ? (
        <img
          src={process.env.REACT_APP_API_URL + iconUrl}
          alt={iconData?.attributes?.alternativeText || alt || "social icon"}
        />
      ) : (
        <span className="footer__link-text">{alt || "Link"}</span>
      )}
    </a>
  );
})}
          </div>
        </div>
        
        <div className="footer__suppot">
          <p>{attributes.support_block?.title}</p>
          {attributes.support_block?.link ? (
            <a
              // Исправлено: безопасный replace, который не упадет, если ссылки нет
              href={`https://t.me/${attributes.support_block.link.replace("@", "")}`}
              target="_blank" 
              rel="noopener noreferrer"
            >
              {attributes.support_block.link}
            </a>
          ) : null}
        </div>
        <p className="footer__copyright">{attributes.copyright}</p>
      </div>
    </div>
  );
};

export default Footer;